export default __webpack_public_path__ + "static/media/domki1.6ea86fd6.jpg";